import { CommonLandingCarousel } from 'app/src/features/Landing/components/CommonLandingCarousel'
import { partnersApi } from 'app/src/services/welfareportal'
import { Image } from 'app/src/shared/components'
import { useWebAppContext } from 'app/src/shared/hooks'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const partnerTemplate = (partner: partnersApi.PartnersBase) => {
  return (
    <div
      className={partner.targetPage ? 'cursor-pointer' : ''}
      onClick={partner.targetPage ? () => window.open(partner.targetPage) : undefined}
    >
      <div className='mb-3'>
        <Image
          pt={{ image: { className: 'max-h-[257px]' } }}
          className='aspect-[3/2] max-h-[257px] object-cover'
          aria-hidden
          alt={partner.title}
          src={partner.imageSrc}
        />
      </div>
    </div>
  )
}

export function PartnerCarouselSection() {
  const { t } = useTranslation('landing')
  const context = useWebAppContext()
  const partnerResult = partnersApi.usePartnersRequestList({
    pathParams: { templateBasePath: context.userInfo.welfareCampaign.configuration.frontend.templateId },
  })

  if (partnerResult.isLoading) {
    return (
      <div className='w-full'>
        <div className='mb-4'>
          <Skeleton height={32} baseColor='#e5e7eb' highlightColor='#f3f4f6' data-testid='loading-element' />
        </div>
        <div className='mt-5'>
          <Skeleton height={257} baseColor='#e5e7eb' highlightColor='#f3f4f6' data-testid='loading-element' />
        </div>
      </div>
    )
  }

  return (
    !partnerResult.isError && (
      <>
        <div>
          <h2 className='welfareportal-titlecenter text-center font-bold text-[#4A4A4A] md:ml-10'>
            {t('Landing.PartnerCarousel.Title')}
          </h2>
        </div>
        <div className='mt-5'>
          <CommonLandingCarousel
            value={partnerResult?.data}
            itemTemplate={partnerTemplate}
            autoplayInterval={3000}
            carouselAriaLabel='Carousel dei partner'
            containerAriaLabel='Elementi del carousel dei partner'
            indicatorsAriaLabel='Indicatori carousel dei partner'
          />
        </div>
      </>
    )
  )
}
